export function blobToDataURL(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function uploadBlobToSignedUrl({uploadUrl, blob, contentType}) {
  if (!uploadUrl || !blob) {
    throw new Error('Missing title frame upload target');
  }

  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: contentType ? {'Content-Type': contentType} : undefined,
    body: blob
  });

  if (!response.ok) {
    throw new Error(`Upload failed with status ${response.status}`);
  }
}

export async function withRetry(fn, {attempts = 2, delayMs = 300} = {}) {
  if (attempts <= 0) {
    throw new Error('withRetry: attempts must be a positive integer');
  }

  let lastError;

  for (let attempt = 1; attempt <= attempts; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;

      if (attempt === attempts) {
        break;
      }

      await new Promise(resolve => setTimeout(resolve, delayMs * attempt));
    }
  }

  throw lastError;
}
